import React from 'react'
import SettingSeoForm from '../components/setting/settingSeoForm'

const SettingsSms = () => {
    return (
        <>
            <SettingSeoForm />
        </>
    )
}

export default SettingsSms